import { showRightSidebarAction, toggleLeftmenu, changeSidebarType, toggleLeftNavBar } from "store/actions";
import { ADMIN_MANAGER_APIS, IS_STAFF_ROLE, IS_SUPERADMIN_ROLE } from "common/ComponentAccess";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { TIME_ZONE, UPDATE_CLOCK_INTERVAL } from "constants/Client";
import { localTimeOfTimezone } from "common/timeConversions";
import AppButton from "component/Buttons/AppButton";
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const Header = () => {
  const dispatch = useDispatch();
  const [currentTime, setcurrentTime] = useState(localTimeOfTimezone("LT MMM DD, YY") || "");

  const { leftNavbar } = useSelector(state => ({
    leftNavbar: state.Layout.leftNavbar,
  }));

  const isAccessable = !ADMIN_MANAGER_APIS();

  const getTime = () => {
    let intervalId = setInterval(() => {
      if (isAccessable) clearInterval(intervalId);
      setcurrentTime(() => localTimeOfTimezone("LT MMM DD, YY"));
    }, UPDATE_CLOCK_INTERVAL);
  };

  useEffect(() => {
    if (localStorage.getItem("navbar")) dispatch(toggleLeftNavBar(JSON.parse(localStorage.getItem("navbar"))));

    if (isAccessable) return;
    getTime();
  }, []);

  function tToggle(state) {
    dispatch(toggleLeftNavBar(state ? state : !leftNavbar));
  }

  return (
    <React.Fragment>
      <header id='page-topbar'>
        <div className='navbar-header'>
          <div className='d-flex'>
            {IS_SUPERADMIN_ROLE() && <h4 className='fw-bold text-white m-0 ms-3 mt-4 mt-lg-0'>Super Admin</h4>}

            <button type='button' onClick={() => tToggle()} className='btn btn-sm px-3 font-size-16 header-item ' id='vertical-menu-btn'>
              <i className='fa fa-fw fa-bars' />
            </button>
          </div>
          <div className='d-flex align-items-center'>
            <div className='d-inline-block'>
              <div>
                {!isAccessable && (
                  <>
                    <span className='d-none d-md-block'>
                      {TIME_ZONE() || "Australia/Sydney"} <span className='d-none d-md-inline'> - {currentTime}</span>
                      {ADMIN_MANAGER_APIS() && <NotificationDropdown />}
                    </span>
                  </>
                )}

                {IS_STAFF_ROLE() && (
                  <AppButton size='md' label='Refresh' prefixIcon={<i className='mdi mdi-reload' />} onClick={() => (window.location = window.location.href)} />
                )}
              </div>
            </div>
            <ProfileMenu />

            {/* <div
               onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
